import Vue from 'vue'

export async function getProveedores(context, [access_token, params, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/proveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })

            context.commit('proveedores/setProveedores', response.data.data, { root: true })
            context.commit('proveedores/setTotalProveedores', response.data.meta.total, { root: true })

        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getMaestrasProveedores(context, [access_token, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/getMaestrasProveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('proveedores/setMaestrasProveedores', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function crearProveedor(context, [access_token, modelProveedor]) {
    try {

        if (access_token) {
            // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/proveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelProveedor
            })

            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateProveedor(context, [access_token,
    modelProveedor,
    regimenesSeleccionados,
    tiposHabitacionSeleccionados,
    caracteristicasHabitacionSeleccionadas,
    tarifasAutoGeneradas]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + modelProveedor.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelProveedor,
                    regimenesSeleccionados,
                    tiposHabitacionSeleccionados,
                    caracteristicasHabitacionSeleccionadas,
                    tarifas: tarifasAutoGeneradas,
                }
            })
            console.log('response:', response);
            if (response.status == 200) {
                context.commit('proveedores/actListProveedores', response.data.data, { root: true })
            }
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}


export async function updateProveedorDatosFiscales(context, [access_token, modelProveedor]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + modelProveedor.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelProveedor
                }
            })
            console.log('response:', response);
            if (response.status == 200) {
                context.commit('proveedores/actListProveedores', response.data.data, { root: true })
            }
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}



export async function eliminarProveedor(context, [access_token, proveedor_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/proveedores/' + proveedor_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })


            if (response.status == 200) {
                context.commit('proveedores/actDeleteListProveedores', proveedor_id, { root: true })
            }
            return response;

            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}



